import Vue from 'vue'
import VueRouter from 'vue-router'
// const _import_ = file => () => import('../components/' + file + '.vue')

const Login = () => import('../components/Login.vue')
const Pdfh5 =  () => import('../components/pdfh5.vue')
const fPdfh5 =  () => import('../components/fpdfh5.vue')
const sPdfh5 =  () => import('../components/spdfh5.vue')
const Protocol = () => import('../components/Protocol.vue')
const OrderList = () => import('../components/orderList')
const Send = () => import('../components/OrderList/Send')
const Harvested = () => import('../components/OrderList/Harvested')
const Reconciliation = () => import('../components/OrderList/Reconciliation')
const Succeed = () => import('../components/OrderList/Succeed')
const Defeated = () => import('../components/OrderList/Defeated')
const Search = () => import('../components/Search/Search.vue')
const Particular = () => import('../components/Particular/Particular.vue')
const ParticularSend = () => import('../components/Particular/ParticularSend.vue')
const ParticularDefeated = () => import('../components/Particular/ParticularDefeated.vue')
const ParticularHarvested = () => import('../components/Particular/ParticularHarvested.vue')
const ParticularReconciliation = () => import('../components/Particular/ParticularReconciliation.vue')
const Classify = () => import('../components/Classify/Classify.vue')
const Cart = () => import('../components/Cart/Cart.vue')
const Index = () => import('../components/index.vue')
const Category = () => import('../components/Classify/Category.vue')
const Details = () => import('../components/Classify/Details.vue')
const My = () => import('../components/My.vue')
const Replenishment = () => import('../components/Replenishment/Replenishment.vue')
const ReplenishmentSend = () => import('../components/Replenishment/ReplenishmentSend.vue')
const ReplenishmentReconciliation = () => import('../components/Replenishment/ReplenishmentReconciliation.vue')
const ReplenishmentSucceed = () => import('../components/Replenishment/ReplenishmentSucceed.vue')
const Orders = () => import('../components/Cart/Orders.vue')
const SendList = () => import('../components/DetailsList/SendList.vue')
const Character = () => import('../components/DetailsList/character.vue')
const SucceedList = () => import('../components/DetailsList/SucceedList.vue')
const ReconciliationList = () => import('../components/DetailsList/ReconciliationList.vue')
const HarvestedList = () => import('../components/DetailsList/HarvestedList.vue')
const DefeatedList = () => import('../components/DetailsList/DefeatedList.vue')
const ParticularSucceed = () => import('../components/Particular/ParticularSucceed.vue')
const Revision = () => import('../components/Cart/revision.vue')
const SucceedDetails = () => import('../components/ReplenishmentDetails/SucceedDetails.vue')
const SendDetails = () => import('../components/ReplenishmentDetails/SendDetails.vue')
const ReconciliationDetails = () => import('../components/ReplenishmentDetails/ReconciliationDetails.vue')
const AddSendDe = () => import('../components/ReplenishmentDetails/AddSendDe.vue')
const NotFind = () => import('../components/404.vue')
const NoAuthority = () => import('../components/502.vue')
const AccountLogin = () => import('../components/accountLogin.vue')
const ResetCode = () => import('../components/reset/ressetcode.vue')
const ResetLogin = () => import('../components/reset/ressetLogin.vue')
const DatumList = () => import('../components/Datum/datumList.vue')
const Preview = () => import('../components/Datum/preview.vue')
const menuList = () => import('../components/menu/index.vue')
const editMenu = () => import('../components/menu/editMenu.vue')
const detailMenu = () => import('../components/menu/detailMenu.vue')
const exterNal = () => import('../components/external.vue')
const ExpenseList = () => import('../components/expense/expense.vue')
const listDetails =  () => import('../components/expense/listDetails.vue')

const Expense = () => import('../components/expense/index.vue')

// 宣传模块 - 无需登录
const Publicity = () => import('../components/Publicity/index.vue')
const PublicityDetails = () => import('../components/Publicity/details.vue')
// 宣传模块 end

// const Viewer = () =>import('../components/Datum/ViewerAsync.vue')

// const menuList = () => import('../components/menu/menuList.vue')


// 解决router版本报错问题
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'hash',
    // 路由跳转后，页面回到顶部
    scrollBehavior() {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    x: 0,
                    y: 0
                })
            }, 0)
        })
    },
    meta: {
        requireAuth: true // 配置此条，进入页面前判断是否需要登陆
    },
    routes: [{
            path: '/menuList',
            component: menuList,
            name: "menuList",
            children: [{
                    path: 'addMenu',
                    component: editMenu
                },
                {
                    path: 'editMenu',
                    component: editMenu
                },
                {
                    path: 'detailMenu',
                    component: detailMenu
                },
            ]
        },
        {
          path: '/Publicity',
          component: Publicity,
        //   meta: {
        //       keepAlive: true,
        //   }
        },
        {
          path: '/PublicityDetails',
          component: PublicityDetails
        },

        {
            path: '/',
            redirect: '/index'
        },
        {
            path: '/Replenishment',
            component: Replenishment,
            children: [{
                    path: 'ReplenishmentSend',
                    component: ReplenishmentSend
                },
                {
                    path: 'ReplenishmentReconciliation',
                    component: ReplenishmentReconciliation
                },
                {
                    path: 'ReplenishmentSucceed',
                    component: ReplenishmentSucceed
                }
            ]
        },
        {
            path: '/revision',
            component: Revision
        },
        {
            path: '/preview',
            component: Preview
        },
        {
            path: '/datumList',
            component: DatumList
        },
        {
            path: '/resetcode',
            component: ResetCode
        },
        {
            path: '/resetlogin',
            component: ResetLogin
        },
        {
            path: '/accountLogin',
            component: AccountLogin
        },
        {
            path: '/AddSendDe',
            component: AddSendDe
        },
        {
            path: '/ReconciliationDetails',
            component: ReconciliationDetails
        },
        {
            path: '/SendDetails',
            component: SendDetails
        },
        {
            path: '/SucceedDetails',
            component: SucceedDetails
        },
        {
            path: '/SendList',
            component: SendList
        },
        {
            path: '/character',
            component: Character
        },
        {
            path: '/SucceedList',
            component: SucceedList
        },
        {
            path: '/ReconciliationList',
            component: ReconciliationList
        },
        {
            path: '/HarvestedList',
            component: HarvestedList
        },
        {
            path: '/DefeatedList',
            component: DefeatedList
        },
        {
            path: '/my',
            component: My
        },
        {
            path: '/external',
            component: exterNal
        },
        {
            path: '/orders',
            component: Orders
        },
        {
            path: '/index',
            component: Index
        },
        {
            path: '/details',
            component: Details
        },
        {
            path: '/login',
            component: Login
        },
        {
            path: '/spdfh5',
            component: sPdfh5
        },
        {
            path: '/fpdfh5',
            component: fPdfh5
        },
        {
            path: '/pdfh5',
            component: Pdfh5
        },
        {
            name: 'protocol',
            path: '/protocol',
            component: Protocol,
            meta: {
                requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的        
            },
        },
        {
            path: '/search',
            component: Search,
        },
        {
            path: '/cart',
            component: Cart
        },
        {
            path: '/category',
            component: Category
        },
        {
            path: '/expense',
            name:'expense',
            component: Expense,
            children:[
                {
                    path: 'list',
                    component: ExpenseList,
                    meta:{
                        keepAlive: true, // 此组件需要被缓存
                    }
                },
                {
                    path: 'detail',
                    component: listDetails, 
                    meta:{
                        keepAlive: false, 
                    }
                }
            ]
        },
        {
            path: '/orderList',
            component: OrderList,
            children: [{
                    path: 'send',
                    component: Send
                },
                {

                    path: 'harvested',
                    component: Harvested
                },
                {
                    path: 'reconciliation',
                    component: Reconciliation
                },
                {
                    path: 'defeated',
                    component: Defeated
                },
                {
                    path: 'succeed',
                    component: Succeed
                },
            ]
        },
        {
            path: '/particular',
            component: Particular,
            children: [{
                    path: 'particularSend',
                    component: ParticularSend
                },
                {
                    path: 'particularDefeated',
                    component: ParticularDefeated
                },
                {
                    path: 'particularHarvested',
                    component: ParticularHarvested
                },
                {
                    path: 'particularReconciliation',
                    component: ParticularReconciliation
                },
                {
                    path: 'particularSucceed',
                    component: ParticularSucceed
                }
            ]
        },
        {
            path: '/classify',
            component: Classify
        },
        {
            path: '/404',
            name: '404',
            description: '404',
            component: NotFind,
        },
        {
            path: '/502',
            name: '502',
            description: '502',
            component: NoAuthority,
        },
        {
            path: '*',
            name: '',
            description: '*',
            redirect: {
                path: '/404'
            }
        },

    ],
});

// 导航守卫
router.beforeEach((to, from, next) => {
    // 解决页面切换时始终回到最顶部
    const token = localStorage.getItem('token')
    // to.query.companyId = companyId

    // 宣传模块 - 无需登录
    if (to.path === '/Publicity' || to.path === '/PublicityDetails') {
      next()
      return
    }
    if (to.path === '/orderList') {
        next('/orderList/send')
    } else if (to.path === '/Replenishment') {
        next('/Replenishment/ReplenishmentSend')
    } else if (to.path === '/particular') {
        next('/particular/particularSend')
    } else if (to.path === '/login' || token || to.path === '/protocol' || to.path === '/accountLogin' || to.path === '/resetlogin' || to.path === '/resetcode' || to.path === "/pdfh5" || to.path === "/fpdfh5" || to.path === "/spdfh5") {
        next()
    } else if (to.path == '/index') {
        next()
    } else {
        next('/accountLogin')
    }
})

export default router